export default __webpack_public_path__ + "static/media/placeholderImageForSection.9763b1ed.svg";